var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-map',{attrs:{"page":"publish","title":"Publish"}})
}
var staticRenderFns = []

export { render, staticRenderFns }